import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DEFAULT_WHATSAPP } from "@/lib/constants";

const Ctx = createContext(null);
const DEFAULTS = {
  company_name: "Ocean Wings Travel",
  website: "www.oceanwingstravel.com",
  whatsapp: DEFAULT_WHATSAPP,
  phone: "",
  email: "",
  address: "",
  office_hours: "",
};

export const SiteDataProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.allSettled([api.get("/settings"), api.get("/packages")])
      .then(([s, p]) => {
        if (s.status === "fulfilled") setSettings({ ...DEFAULTS, ...s.value.data, whatsapp: s.value.data.whatsapp || DEFAULT_WHATSAPP });
        if (p.status === "fulfilled") setPackages(p.value.data);
      })
      .finally(() => setLoading(false));
  }, []);

  return <Ctx.Provider value={{ settings, setSettings, packages, loading }}>{children}</Ctx.Provider>;
};

export const useSiteData = () => useContext(Ctx);
